//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Accordion from '~/components/accordion'
import svgSymbol from '~/components/svg-symbol'

export default {

	// functional: true,

	components: { Accordion, svgSymbol },

	props:
	{
		list:
		{
			type: Array,
			required: true,
		}
	},

}
